import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "@tanstack/react-query";
import { addParticipant } from "../../components/MySurveys/MySurveys.api";
import { useAuth } from "context/auth-context";
import Pagination from "../Pagination/Pagination";
import { AttemptDataType } from "components/MySurveys/intial-data";
import MySurveysListHandler from "components/MySurveys/utils/MySurveysListHandler";
import SurveyCard from "./SurveyCard";
import NavCard from "components/Dashboard/NavCard";
import SurveysSub from "./Menus/SurveysSub";
import { QualificationPopUp } from "./QualificationPopup";
import { getDataa, useSurveyQuery } from "./CommonComponent";
import { getHistory } from "components/History/History.api";
import { FiSearch } from "react-icons/fi";
export const SurveyList = ({ type }: any) => {
  const { t } = useTranslation();
  const { auth } = useAuth();
  const [country, setCountry] = useState("");
  const [langCode, setLangCode] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [countryChangeMessage, setCountryChangeMessage] = useState(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [noDataMsg, setNoDataMsg] = useState(false);
  const [recordsPerPage] = useState(10);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const { surveyLength, surveys, isLoading, refetch } = useSurveyQuery(
    country,
    langCode,
    auth.panelistId,
    searchQuery
  );
  const [showQualificationPopup, setShowQualificationPopUp] = useState(false);
  const [selectedSurveyData, setSelectedSurveyData] = useState(null);

  const attemptFunction = useMutation(
    (payload: AttemptDataType) => {
      return addParticipant({ ...payload });
    },
    {
      onError: (e) => alert(e),
      onSuccess: (response, variable) => {
        setShowQualificationPopUp(false);
        if (response && variable.sid) {
          let redirectUrl;
          if (process.env.REACT_APP_ENV === "Production") {
            redirectUrl = `https://zampparticipant.zamplia.com/?vid=313&SID=${variable.sid}&UID=${auth.panelistId}&cid=${variable.apiClientId}&session_id=${response.session_id}&isMap=1`;
          } else {
            redirectUrl = `https://devparticipant.zamplia.com/?vid=313&SID=${variable.sid}&UID=${auth.panelistId}&cid=${variable.apiClientId}&session_id=${response.session_id}&isMap=1`;
          }
          window.open(redirectUrl);
        }
      },
    }
  );

  const getHistoryData = useQuery(
    ["history", currentPage],
    () => getHistory(auth.panelistId, currentPage),
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [type]);

  useEffect(() => {
    getDataa({
      setCountry,
      setLangCode,
      setCountryChangeMessage,
      auth,
      t
    });
  }, []);

  useEffect(() => {
    if (!isLoading && (searchQuery === "" || searchQuery === null)) {
      refetch();
    }
  }, [searchQuery, isLoading]);

  let surveysSet = [];
  if (surveys && surveys.length > 0) {
    const attemptedSurveyIds = new Set(getHistoryData?.data?.result?.historyList.map((item) => item.survey_id));
    const filteredSurveys = surveys.filter(survey => !attemptedSurveyIds.has(survey._id));
    surveysSet = MySurveysListHandler?.wihoutSearch(
      filteredSurveys,
      indexOfFirstRecord,
      indexOfLastRecord,
      attemptFunction,
      auth,
      Number(type)
    );
  }

  useEffect(() => {
    if (surveysSet?.length === 0) {
      setNoDataMsg(true);
    } else {
      setNoDataMsg(false);
    }
  }, [surveysSet]);

  const ClosePupup = () => {
    setShowQualificationPopUp(false);
  };

  const ShowPopup = (surveyData: any) => {
    setSelectedSurveyData(surveyData);
    setShowQualificationPopUp(true);
  };

  return (
    <>
      {showQualificationPopup && (
        <QualificationPopUp
          attemptFunction={attemptFunction.mutate}
          ShowPopup={ClosePupup}
          setSelectedSurveyData={selectedSurveyData}
        />
      )}
      <div className="flex flex-row items-center justify-center h-full px-4  scroll-smooth lg:w-[100vw] xl:w-full">
        <div className="mt-24 lg:ml-[16rem] lg:pl-4 w-full">
          <div className="mb-5 md:mb-6">
            <NavCard />
          </div>
          <div className=" text-neutral-600 md:text-base lg:text-base text-xs font-['Poppins'] lg:ml-8 md:ml-3 ml-3">
            {countryChangeMessage && <div>{countryChangeMessage}</div>}
          </div>
          <div className="block lg:hidden">
            <SurveysSub />
          </div>
          <div className="flex justify-end w-full mb-4 ">
            <div className="flex bg-white rounded-3xl items-center w-full lg:w-[300px] px-6 mt-4 2xl:mt-0 ">
              <FiSearch className="w-10 text-gray-500" />
              <input
                type="text"
                placeholder="Search Surveys..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="p-3 focus:outline-none w-full"
              />
            </div>
          </div>

          <div className="bg-white lg:h-full mb-20 rounded-[22px] mt-4 h-full w-full pb-20 lg:pb-0 md:pb-0 mx-0 font-Poppins">
            <div className='text-neutral-500 text-lg font-semibold font-["Poppins"] md:text-center lg:text-start text-center pt-6 pb-8 lg:pl-16'>
              {t("survey.card.Surveys")}!
            </div>
            {noDataMsg && !isLoading && <div className="inset-0 flex items-center justify-center text-base font-normal md:mb-14 text-neutral-600">{t("page.mysurvey.nodata")} !!</div>}
            {isLoading && <div className="visually-hidden inset-0 flex items-center justify-center text-base font-normal md:mb-14 text-neutral-600">{t("page.referral.Loading")}</div>}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 lg:ml-16">
              {surveysSet?.map((surveyData, index) => (
                <SurveyCard
                  key={index}
                  ShowPopup={ShowPopup}
                  minutes={surveyData.loi}
                  points={Math.floor(surveyData.points)}
                  surveyName={surveyData.studyName}
                  attemptFunction={attemptFunction.mutate}
                  surveyData={surveyData}
                />
              ))}
            </div>
            {surveysSet.length > 0 && (
              <div className="flex justify-center mt-12 font-poppins">
                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalPages={Math.ceil(surveyLength / 10)}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default SurveyList;